import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useStores } from '@/hooks/use-stores';
import { observer } from 'mobx-react';
import { MOBILE_STEPS } from './MobileUploadWizzard.consts';
import { StyledDrawer } from './MobileUploadWizzard.styles';

interface Props {
  open: boolean;
  onClose: () => void;
  onComplete: () => void;
}

export const MobileUploadWizzard: FC<Props> = observer(({ open, onClose, onComplete }) => {
  const { t } = useTranslation();
  const { imageUploadStore } = useStores();

  const { label, component: Step } = MOBILE_STEPS[imageUploadStore.currentStep];

  return (
    <StyledDrawer
      zIndex={1201}
      open={open}
      onClose={onClose}
      placement="bottom"
      title={<p className="modal-title">{t(label)}</p>}
      height="100%"
      destroyOnClose
    >
      <div className="step-container">
        <Step onComplete={onComplete} layout="mobile" />
      </div>
    </StyledDrawer>
  );
});
